import { useEffect } from 'react';
import Navbar from '../../components/feature/Navbar';
import Footer from '../../components/feature/Footer';
import SeoHead from '../../components/feature/SeoHead';
import VisionHero from './components/VisionHero';
import VisionStatement from './components/VisionStatement';
import SDGsCommitment from './components/SDGsCommitment';
import FutureGoals from './components/FutureGoals';
import RegionalCreation from './components/RegionalCreation';

const siteUrl = (import.meta.env.VITE_SITE_URL as string | undefined) ?? '';

const visionJsonLd = {
  '@context': 'https://schema.org',
  '@type': 'WebPage',
  name: 'ビジョン | 株式会社C.GREEN | SDGs・地域創生・持続可能な社会',
  url: `${siteUrl}/vision`,
  description:
    '株式会社C.GREENのビジョンとSDGsへの取り組みをご紹介。持続可能な地域社会の実現に向けた未来目標・地域創生の理念を解説します。',
  inLanguage: 'ja',
  breadcrumb: {
    '@type': 'BreadcrumbList',
    itemListElement: [
      { '@type': 'ListItem', position: 1, name: 'ホーム', item: siteUrl },
      { '@type': 'ListItem', position: 2, name: 'ビジョン', item: `${siteUrl}/vision` },
    ],
  },
};

export default function VisionPage() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <SeoHead
        title="ビジョン | 株式会社C.GREEN | SDGs・地域創生・持続可能な社会"
        description="株式会社C.GREENのビジョンとSDGsへの取り組みをご紹介。持続可能な地域社会の実現に向けた未来目標・地域創生の理念を解説します。"
        keywords="C.GREENビジョン,SDGs,持続可能な社会,地域創生,未来目標,環境経営"
        canonicalPath="/vision"
        jsonLd={visionJsonLd}
      />
      <Navbar />
      <VisionHero />
      <VisionStatement />
      <SDGsCommitment />
      <RegionalCreation />
      <FutureGoals />
      <Footer />
    </div>
  );
}
